import { AppBadge, type BadgeColor } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { INQUIRY_ASSIGN_STATUS_COLOR_MAP, INQUIRY_ASSIGN_STATUS_DEFS, type InquiryAssignStatus } from 'shared'

interface InquiryStatusBadgeProps {
  statusId: number | undefined
}

/**
 * 引合アサインステータスIDから対応するバッジを表示する。
 * 共通の色マップを使うことで、他画面のバッジと見た目を揃える。
 */
export function InquiryStatusBadge({ statusId }: InquiryStatusBadgeProps) {
  const name = INQUIRY_ASSIGN_STATUS_DEFS.find((d) => d.id === statusId)?.name as InquiryAssignStatus | undefined
  if (!name) return null
  return <AppBadge color={INQUIRY_ASSIGN_STATUS_COLOR_MAP[name] as BadgeColor}>{name}</AppBadge>
}
